/**
 * Create store system routing-secuiRip
 *
 * @since 2018-07-09
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // rip config
    ripngConfig: `${smApiPrefix}/ipv6/ripng/config`,
    // rip status
    ripngStatus: `${smApiPrefix}/ipv6/ripng/config/status`,
    // network list
    ripngNetworks: `${smApiPrefix}/ipv6/ripng/config/networks`,
    // rip advance
    ripngAdvance: `${smApiPrefix}/ipv6/ripng/config/advance`,
    // rip apply
    ripngApply: `${smApiPrefix}/ipv6/ripng/config/apply`,
    // rip cancel
    ripngCancel: `${smApiPrefix}/ipv6/ripng/config/cancel`
  },
  // copyData of editing.
  selectedItem: {},
  // rip config
  ripConfig: {
    enable: 0 //      required (one of 0, 1)
  },
  // clone of ripConfig
  ripConfigClone: {
    enable: 0 //      required (one of 0, 1)
  },
  // rip status
  ripStatus: {
    status: ''
  },
  ripNetwork: {
    id: 0,
    network_addr: null, //  네트워크 IP 주소
    network_mask: 0 //      네트워크 IP mask
  },
  ripNetworkList: [],
  ripAdvance: {
    metric: 1, //           required (integer - default: 1 - minimum: 1 - maximum: 16)
    update_timer: 30, //    required (number - default: 30 - minimum: 5 - maximum: 2147483647)
    tm_out_timer: 180, //   required (number - default: 180 - minimum: 5 - maximum: 2147483647) Timeout
    flush_timer: 120, //    required (number - default: 120 - minimum: 5 - maximum: 2147483647) Garbage
    static_enable: 0, //    required (one of 0, 1) use (OFF: 0, ON: 1)
    static_metric: 1, //    required (integer - minimum: 1 - maximum: 16) Static
    ospf_enable: 0, //      required (one of 0, 1) use (OFF: 0, ON: 1)
    ospf_metric: 1, //      required (integer - minimum: 1 - maximum: 16) OSPF
    bgp_enable: 0, //       required (one of 0, 1) use (OFF: 0, ON: 1)
    bgp_metric: 1 //        required (integer - minimum: 1 - maximum: 16) BGP
  }
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  resetRipConfig (state) {
    state.ripConfig.enable = 0
  },
  setRipConfig (state, data) {
    if (data !== undefined) {
      state.ripConfig.enable = data.enable
      // clone
      state.ripConfigClone.enable = _.cloneDeep(data.enable)
    }
  },
  resetRipStatus (state) {
    state.ripStatus.status = ''
  },
  setRipStatus (state, data) {
    if (data !== undefined) {
      state.ripStatus.status = data.status
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip network
  // network dialog
  clearRipNetworkDialog (state) {
    state.ripNetwork.id = 0
    state.ripNetwork.network_addr = null
    state.ripNetwork.network_mask = 0
  },
  setRipNetworkDialog (state, item) {
    state.ripNetwork.id = item.id
    state.ripNetwork.network_addr = item.network_addr
    state.ripNetwork.network_mask = item.network_mask
  },
  resetRipNetworkList (state) {
    state.ripNetworkList = []
  },
  setRipNetworkList (state, data) {
    if (data !== undefined) {
      state.ripNetworkList = data
    }
  },
  addRipNetworkList (state, item) {
    if (item !== undefined) {
      state.ripNetworkList.push(item)
    }
  },
  editRipNetworkList (state, item) {
    const findRslt = _.find(state.ripNetworkList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ripNetworkList.splice(_.findIndex(state.ripNetworkList, state.selectedItem), 1, item)
    }
  },
  delRipNetworkList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ripNetworkList.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip advance
  resetRipAdvanceSetInfo (state) {
    state.ripAdvance.metric = 1
    state.ripAdvance.update_timer = 30
    state.ripAdvance.tm_out_timer = 180
    state.ripAdvance.flush_timer = 120
    state.ripAdvance.static_enable = 0
    state.ripAdvance.static_metric = 1
    state.ripAdvance.ospf_enable = 0
    state.ripAdvance.ospf_metric = 1
    state.ripAdvance.bgp_enable = 0
    state.ripAdvance.bgp_metric = 1
  },
  setRipAdvanceSetInfo (state, data) {
    if (data !== undefined) {
      state.ripAdvance.metric = data.metric
      state.ripAdvance.update_timer = data.update_timer
      state.ripAdvance.tm_out_timer = data.tm_out_timer
      state.ripAdvance.flush_timer = data.flush_timer
      state.ripAdvance.static_enable = data.static_enable
      state.ripAdvance.static_metric = data.static_metric
      state.ripAdvance.ospf_enable = data.ospf_enable
      state.ripAdvance.ospf_metric = data.ospf_metric
      state.ripAdvance.bgp_enable = data.bgp_enable
      state.ripAdvance.bgp_metric = data.bgp_metric
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip config
  async getRipConfig ({commit, state}, loadingOpt) {
    commit('resetRipConfig')
    const apiUrl = state.apiUrlPath['ripngConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipConfig', result)
      return true
    } else {
      return false
    }
  },
  async editRipConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['ripngConfig']
    const rslt = await this.$axios.$put(apiUrl, state.ripConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setRipConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip config
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip status
  async getRipStatus ({commit, state}) {
    commit('resetRipStatus')
    const apiUrl = state.apiUrlPath['ripngStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipStatus', result)
      return true
    } else {
      return false
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip status
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip network
  async getNetworkList ({commit, state}, loadingOpt) {
    commit('setRipNetworkList')
    const apiUrl = state.apiUrlPath['ripngNetworks']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipNetworkList', result)
      return true
    } else {
      return false
    }
  },
  // add , // edit , // del(multi)
  async addRipNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ripngNetworks']
    const addParam = {
      network_addr: state.ripNetwork.network_addr,
      network_mask: Number(state.ripNetwork.network_mask)
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addRipNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editRipNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ripngNetworks']
    const putParam = {
      network_addr: state.ripNetwork.network_addr,
      network_mask: Number(state.ripNetwork.network_mask)
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.ripNetwork.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editRipNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delRipNetworkList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ripngNetworks']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delRipNetworkList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip network
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip advacne
  async getRipAdvacne ({commit, state}) {
    commit('resetRipAdvanceSetInfo')
    const rslt = await this.$axios.$get(state.apiUrlPath['ripngAdvance'])
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setRipAdvanceSetInfo', rslt.result)
      return true
    } else {
      return false
    }
  },
  async editRipAdvanceSetInfo ({commit, state}) {
    const putParam = _.cloneDeep(state.ripAdvance)
    const {code, result} = await this.$axios.$put(state.apiUrlPath['ripngAdvance'], putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipAdvanceSetInfo', result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip advance
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip apply & cancel
  async setRipApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ripngApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setRipCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ripngCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip apply & cancel
}

export const getters = {
  // rip Config
  compareRipngConfigData (state) {
    return compareObject(state.ripConfig, state.ripConfigClone)
  }
}

export const strict = false
